import React, { Suspense } from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import "./App.css";
import Login from "./components/Auth/Login";
import Header from "./components/Header/Header";
import Loader from "./components/Loader";
import { getBoolVal, RouteConstants } from "./utils";
// import Footer from "./components/Footer/Footer";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Local_Variables, Logout } from "./actions/auth";
import Account from "./components/Account/Account";
import AccountTransaction from "./components/Account/AccountTransaction";
import Advances from "./components/Advances/Advances";
import AdvanceDetail from "./components/Advances/AdvancesDetail";
import Analytics from "./components/Analytics/Analytics";
import Cards from "./components/Cards/Card";
import CardDetails from "./components/Cards/CardDetails";
import CardInventory from "./components/Cards/CardInventory";
import CardTransactions from "./components/Cards/CardTransactions";
import SetIn from "./components/Common/SetIn";
import Success from "./components/Common/Success";
import AdminDashboard from "./components/Dashboard_Emp/Dashboard";
import Dashboard from "./components/Dashboard_New/Dashboard";
import Expenses from "./components/Expenses/Expenses";
import LeftNavigation from "./components/LeftNavigation/LeftNavigation";
import ExpensesDetails from "./components/Reports/ExpensesDetails";
import Reports from "./components/Reports/Report";
import ReportDetail from "./components/Reports/ReportDetail";
import Settings from "./components/Settings/Setting";
import AddBulkUsers from "./components/Settings/UsersControls/Users/AddBulkUsers";
import BulkTransfers from "./components/Transfers/BulkTransfers";
import TransferLog from "./components/Transfers/TransferLog";
import Transfers from "./components/Transfers/Transfers";
// import AddTrip from "./components/Trips/AddTrip";
import Activity from "./components/Activity/Activity";
import Beneficiary from "./components/Beneficiary/Beneficiary";
import SetPin from "./components/Cards/SetPin";
import DownloadCSV from "./components/Common/DownloadCSV";
import IdleLogout from "./components/Common/IdleTimer";
import PaymentGateway from "./components/Common/PaymentGateway";
import ReportAction from "./components/Common/ReportAction";
import DeleteSteps from "./components/DeleteSteps";
import Disputes from "./components/Disputes/Disputes";
import AddExpenses from "./components/Expenses/AddExpenses";
import AddBulkExpense from "./components/Expenses/BulkAddExpense";
import Footer from "./components/Footer/Footer";
import Policies from "./components/Policies";
import TermsNConditions from "./components/TermsNConditions";
import AddTripComponent from "./components/Trips/AddTripComponent";
import Trips from "./components/Trips/Trips";
import TripsDetail from "./components/Trips/TripsDetail";
import ErrorModal from "./config/ErrorModal";
import history from "./history";
import BatchDownload from "./components/Common/BatchDownload";
import UserDashboard from "./components/Checker/UserDashboard";
import CheckerTransfers from "./components/Checker/Transfers";
import UserLogs from "./components/Transfers/UserLogs";
import { Col, Row } from "antd";

const DeleteVideo = React.lazy(
  () => import("./components/Common/DeleteAccVideo"),
);

// import { getTokenStr as getToken, onMessageListener } from "./config/firebaseInit";
export const HeaderFooterWrap = (props) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch({
      type: Local_Variables,
      payload: {
        is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
      },
    });

    // eslint-disable-next-line
  }, []);

  const menu = sessionStorage.getItem("menu")
    ? Object.keys(JSON.parse(sessionStorage.getItem("menu")))
    : [];

  return (
    <div>
      <div className="fixed-header">
        <Header />
      </div>
      <Row className="main-content">
        {props.noNav ? null : (
          <Col xs={24} sm={6} md={4} lg={4} xl={4} xxl={3} className="left-nav">
            <div className="fixed-nav" style={{ width: "16%" }}>
              <LeftNavigation />
            </div>
          </Col>
        )}
        <Col
          xs={24}
          sm={18}
          md={20}
          lg={20}
          xl={20}
          xxl={21}
          className="pt1 pl2 pr2"
        >
          <div
            className="fixed-content"
            style={{
              // width: props.noNav ? "100%" : "85%",
              // paddingRight: "2%",
              left: props.noNav ? "0" : undefined,
            }}
          >
            {(!getBoolVal(sessionStorage.getItem("is_super_admin")) &&
              props.role &&
              !menu.includes(props.role) &&
              getBoolVal(sessionStorage.getItem("is_admin"))) ||
              props.noPermission ? (
              <div>This user does not have permission for {props.name}</div>
            ) : (
              <>{props.children}</>
            )}
            <Footer />
          </div>
        </Col>
      </Row>
    </div>
  );
};

function PrivateRoute({ children, path, exact }) {
  return (
    <Route
      path={path}
      exact={exact}
      render={() => {
        return sessionStorage.getItem("token") ? children : <Redirect to="/" />;
      }}
    />
  );
}

function App() {
  const [isLoading, setIsLoading] = React.useState(true);
  const logoutResponse = useSelector((state) => state.auth.logout || {});
  const topup = useSelector((state) => state.cards.topup);
  const uploadData = useSelector((state) => state?.cards?.uploadBulk);
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );
  const cards_loading = useSelector(
    (state) => state.analytics.analytics_cards?.loading,
  );
  const blockCardResponseLoading = useSelector(
    (state) => state.cards.block?.loading,
  );
  const replacementResponseLoading = useSelector(
    (state) => state.cards.replacement?.loading,
  );
  const card_enalbe_loading = useSelector(
    (state) => state.cards.card_enable?.loading,
  );
  const corporate_budget_response = useSelector(
    (state) => state.cards.corporate_budget?.data?.response,
  );
  const dispatch = useDispatch();

  React.useEffect(() => {
    hideLoader();
    // getToken();
    // onMessageListener().then(payload => {
    //   console.log("notification......", payload);
    // })
  }, []);

  React.useEffect(() => {
    setIsLoading(
      topup?.loading ||
      uploadData?.loading ||
      cards_loading ||
      card_enalbe_loading ||
      blockCardResponseLoading ||
      replacementResponseLoading,
    );
  }, [
    topup?.loading,
    uploadData?.loading,
    cards_loading,
    card_enalbe_loading,
    blockCardResponseLoading,
    replacementResponseLoading,
  ]);

  const hideLoader = () => {
    const proc = new Promise((resolve) => {
      setTimeout(() => resolve(), 50);
    });
    proc.then(() => setIsLoading(false));
  };

  React.useEffect(() => {
    if (logoutResponse.success) {
      sessionStorage.clear();
      history.push(RouteConstants.ROOT);
      window.location.reload(false);
      dispatch({
        type: Logout.RESET,
      });
    } else if (logoutResponse.success === false) {
      dispatch({
        type: Logout.RESET,
      });
      sessionStorage.clear();
      history.push(RouteConstants.ROOT);
      window.location.reload(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoutResponse]);

  React.useEffect(() => {
    if (corporate_budget_response?.success) {
    } else {
      if (corporate_budget_response?.message) {
        sessionStorage.clear();
        history.push(RouteConstants.ROOT);
        window.location.reload(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [corporate_budget_response]);
  // const token = sessionStorage.getItem("token")
  return (
    <div className="App">
      {/* {token && <TabCloseWarning handler={() => 'You’ll lose your session, are you sure you want to continue ?'}/>} */}
      {isLoading ? <Loader /> : null}
      <Router history={history}>
        <Switch>
          <Route path="/" component={Login} exact />
          <Route path="/request-demo" component={Login} />
          <Route path="/reset-password" component={Login} />
          <Route path="/set-password" component={Login} />
          <Route path="/forgot-password/" component={Login} />
          <Route path="/confirm_email/" component={Login} />
          {/* <PrivateRoute path="/dashboard/">
            <HeaderFooterWrap role="dashboard" name="Dashboard">
              <DashboardNew />
            </HeaderFooterWrap>
          </PrivateRoute> */}
          <PrivateRoute path="/dashboard/">
            <HeaderFooterWrap role="dashboard" name="Dashboard">
              {is_admin ? <AdminDashboard /> : <Dashboard />}
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/setting/">
            <HeaderFooterWrap noPermission={!is_admin}>
              <Settings />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/policies/">
            <HeaderFooterWrap>
              <Policies />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/disputes/">
            <HeaderFooterWrap>
              <Disputes />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/reports/">
            <HeaderFooterWrap role="expense_reports" name="Reports">
              <Reports />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/expenses/">
            <HeaderFooterWrap role="expenses" name="Expenses">
              <Expenses />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/trips/">
            <HeaderFooterWrap role="trips" name="Trips">
              <Trips />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/add-trip/">
            <HeaderFooterWrap role="trips" name="Trips">
              <AddTripComponent />
            </HeaderFooterWrap>
          </PrivateRoute>
          {/* <PrivateRoute path="/add-trip-new/">
            <HeaderFooterWrap>
              <AddTripComponent />
            </HeaderFooterWrap>
          </PrivateRoute> */}
          <PrivateRoute path="/trip-details/:id">
            <HeaderFooterWrap role="trips" name="Trips">
              <TripsDetail />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/advances/">
            <HeaderFooterWrap role="advances" name="Advances">
              <Advances />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/advance-details/:id">
            <HeaderFooterWrap role="advances" name="Advances">
              <AdvanceDetail />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/report-details/:id">
            <HeaderFooterWrap role="expense_reports" name="Reports">
              <ReportDetail />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/expense-details">
            <HeaderFooterWrap role="expense_reports" name="Expenses">
              <ExpensesDetails />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/expense-add">
            <HeaderFooterWrap role="expense_reports" name="Expenses">
              <AddExpenses />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/bulk-expense-add">
            <HeaderFooterWrap role="expense_reports" name="Expenses">
              <AddBulkExpense />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/cards/">
            <HeaderFooterWrap role="cards" name="Cards">
              <Cards />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/card-details/">
            <HeaderFooterWrap role="cards" name="Cards">
              <CardDetails />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/card-transactions/">
            <HeaderFooterWrap
              role="transactions"
              name="Cards"
              noPermission={!is_admin}
            >
              <CardTransactions />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/card-inventory/">
            <HeaderFooterWrap
              role="cards"
              name="Cards"
              noPermission={!is_admin}
            >
              <CardInventory />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/transfers/quick-transfers/">
            <HeaderFooterWrap role="transfers" name="Transfers">
              <Transfers />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/transfers/bulk-transfers/">
            <HeaderFooterWrap role="transfers" name="Transfers">
              <BulkTransfers />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/transfers/transfers-log/">
            <HeaderFooterWrap role={"cc_transfer_logs"} name="Transfers">
              <TransferLog />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/checker/user-logs">
            <HeaderFooterWrap role="cc_user_logs" name="User Logs">
              <UserLogs />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/transfers/transfers-reports/">
            <HeaderFooterWrap role="transfers" name="Transfers">
              <BulkTransfers />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/account/">
            <HeaderFooterWrap
              role="account"
              name="Account"
              noPermission={!is_admin}
            >
              <Account />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/upload-bulk-users/">
            <HeaderFooterWrap noPermission={!is_admin}>
              <AddBulkUsers />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/analytics">
            <HeaderFooterWrap
              role="analytics"
              name="Analytics"
              noPermission={!is_admin}
            >
              <Analytics />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/account-transaction/">
            <HeaderFooterWrap
              role="account"
              name="Account"
              noPermission={!is_admin}
            >
              <AccountTransaction />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/beneficiary">
            <HeaderFooterWrap role="beneficiary" name="beneficiary">
              <Beneficiary />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/activity">
            <HeaderFooterWrap name="activity">
              <Activity />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/set-pin">
            <HeaderFooterWrap noNav={true}>
              <SetPin />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/checker/users">
            <HeaderFooterWrap role="cc_user_approvals">
              <UserDashboard />
            </HeaderFooterWrap>
          </PrivateRoute>
          <PrivateRoute path="/transfers">
            <HeaderFooterWrap role="cc_transfer_approvals">
              <CheckerTransfers />
            </HeaderFooterWrap>
          </PrivateRoute>
          <Route path={"/success"} component={Success} />
          <Route path={"/pinset"} component={SetIn} />
          <Route path={"/download-csv"} component={DownloadCSV} />
          <Route path={"/payment_gateway"} component={PaymentGateway} />
          {/* <Route
            path={"/grievance-policy"}
            render={() => <TermsNConditions index={1} />}
          /> */}
          <Route
            path={"/refund-policy"}
            render={() => <TermsNConditions index={4} />}
          />
          <Route
            path={"/privacy"}
            render={() => <TermsNConditions index={3} />}
          />
          <Route
            path={"/terms-n-conditions"}
            render={() => <TermsNConditions index={1} />}
          />
          {/* <Route path={"/payment-gateway-policies"} render={() => <TermsNConditions index={4} />} /> */}
          <Route
            path={"/payment-gateway-refund-policy"}
            render={() => <TermsNConditions index={0} />}
          />
          {/* add routes */}
          <Route
            path={"/about-product"}
            render={() => <TermsNConditions index={6} />}
          />
          <Route
            path={"/about-us"}
            render={() => <TermsNConditions index={7} />}
          />
          <Route
            path={"/refund-policy"}
            render={() => <TermsNConditions index={3} />}
          />

          <Route path={"/faqs"} render={() => <TermsNConditions index={5} />} />
          <Route
            path={"/flow-of-transaction"}
            render={() => <TermsNConditions index={2} />}
          />
          <Route
            path={"/cancellation"}
            render={() => <TermsNConditions index={8} />}
          />
          <Route
            path={"/card-member-declaration"}
            render={() => <TermsNConditions index={5} />}
          />
          {/* <Route
            path={"/pep-disclosure"}
            render={() => <TermsNConditions index={7} />}
          />
          <Route
            path={"/fatca-declaration"}
            render={() => <TermsNConditions index={8} />}
          />
          <Route
            path={"/cancellation"}
            render={() => <TermsNConditions index={9} />}
          />
          <Route
            path={"/flow-of-transaction"}
            render={() => <TermsNConditions index={10} />}
          />
          <Route
            path={"/pricing"}
            render={() => <TermsNConditions index={11} />}
          />
          <Route
            path={"/amendment-term-conditions"}
            render={() => <TermsNConditions index={12} />}
          />
          <Route
            path={"/definitions"}
            render={() => <TermsNConditions index={13} />}
          /> */}
          <Route
            path={"/report-approve/:id"}
            render={() => <ReportAction type="approve" />}
          />
          <Route
            path={"/report-reject/:id"}
            render={() => <ReportAction type="reject" />}
          />
          <Route
            path={"/delete-account"}
            render={() => (
              <Suspense fallback={<Loader />}>
                <DeleteVideo />
              </Suspense>
            )}
          />
          <Route path={"/file_download"} render={() => <BatchDownload />} />
          <Route path={"/delete/user/account"} render={() => <DeleteSteps />} />
        </Switch>
      </Router>
      <ErrorModal />
      <IdleLogout />
    </div>
  );
}

export default App;
